<app-page-meta pageTitle="finzy - Manual Invest"></app-page-meta>
<app-header></app-header>
<div class="mainrowMobile">
  <p class="finzy-invest-p-mobile">This feature is available only on finzy web version, kindly log onto web version to
    continue.</p>
</div>
<div class="mainrow  finzy-container-padding-bottom container-fluid full-height">

  <div class="col col-md-9 finzy-container-padding-2" *ngIf="areLoansAvailable()">

    <p class="finzy-invest-p-alt">Listed below are a choice of loans currently available on the platform. However, you
      can choose <span class="finzy-pro-know-no-underline">finzyPRO+</span> to create your investment portfolio.
      <br/>
      Read more about how finzyPRO+ works <a class="finzy-anchor" href="/faq" style="font-size: 16px;">here</a>
    </p>

    <div class="col-md-12 finzy-padding-zero">
      <div class="col-md-8 finzy-padding-zero finzy-container-padding-top-bottom">
        <p class="finzy-interest-text">CHOOSE YOUR RISK APPPETITE</p>
        <!-- <div class="finzy-conservative finzy-risk-active finzy-risk-bucket-container">
          <input type="checkbox" class="finzy-risk-bucket-input" name="toggle"
                 (change)="changeRisk('A+',$event.target.checked)">
          <span class="finzy-risk-bucket-title finzy-risk-bucket-title-color-4">A+</span>

          <p class="finzy-bucket-sub-title-1">A+1 - A+3</p>
          <p class="finzy-bucket-sub-title-2">7.99% - 9.99%</p>

        </div> -->
        <div class="finzy-conservative finzy-risk-active finzy-risk-bucket-container">
          <input type="checkbox" class="finzy-risk-bucket-input" name="toggle"
                 (change)="changeRisk('A',$event.target.checked)">
          <span class="finzy-risk-bucket-title finzy-risk-bucket-title-color-1">A</span>

          <p class="finzy-bucket-sub-title-1">A1 - A6</p>
          <p class="finzy-bucket-sub-title-2">10.99% - 15.99%</p>

        </div>

        <div class="finzy-conservative finzy-risk-active finzy-risk-bucket-container">

          <input type="checkbox" class="finzy-risk-bucket-input" name="toggle"
                 (change)="changeRisk('B',$event.target.checked)">

          <span class="finzy-risk-bucket-title finzy-risk-bucket-title-color-2">B</span>

          <p class="finzy-bucket-sub-title-1">B1 - B6</p>
          <p class="finzy-bucket-sub-title-2">16.99% - 21.99%</p>

        </div>

        <div class="finzy-conservative finzy-risk-active finzy-risk-bucket-container">

          <input type="checkbox" class="finzy-risk-bucket-input" name="toggle"
                 (change)="changeRisk('C',$event.target.checked)">

          <span class="finzy-risk-bucket-title finzy-risk-bucket-title-color-3">C</span>

          <p class="finzy-bucket-sub-title-1">C1 - C6</p>
          <p class="finzy-bucket-sub-title-2">22.99% - 27.99%</p>

        </div>

      </div>
    </div>

    <div class="col-md-12 finzy-select-container">

      <p class="finzy-filters-text">FILTER BORROWER LISTING</p>
      <mat-form-field>
        <mat-select placeholder="LOCATION" [(ngModel)]="selectedLocationToFilter" name="location"
                    class="finzy-invest-select">
          <mat-option value=""> Select All</mat-option>

          <mat-option *ngFor="let location of locationOptions" [value]="location" class="finzy-invest-option">
            {{ location }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="RATING" [(ngModel)]="selectedRatingToFilter" name="rating" class="finzy-invest-select">
          <mat-option value=""> Select All</mat-option>
          <mat-option *ngFor="let rating of ratingOptions" [value]="rating">
            {{ rating }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="FILLED (%)" [(ngModel)]="selectedFilledPercentageToFilter" name="filled"
                    class="finzy-invest-select">
          <mat-option *ngFor="let filled of filledOptions" [value]="filled.value">{{ filled.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="finzy-manualinvest-table">

      <table mat-table *ngIf="areLoansAvailable()"
             [dataSource]="dataSource | ratingFilter: selectedRatingRangeToFilter | singleRatingFilter: selectedRatingToFilter |
                 locationFilter: selectedLocationToFilter | filledPercentageFilter: selectedFilledPercentageToFilter"
             matSort>
        <ng-container matColumnDef="roi" class="finzy-mat-roi">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> ROI %</th>
          <td mat-cell (click)="openDialog(element)" *matCellDef="let element"> {{element.roi | number : '1.2-2'}}
          </td>
        </ng-container>

        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef> LOCATION</th>
          <td mat-cell *matCellDef="let element"> {{element.correspondence_address.city }}</td>
        </ng-container>

        <ng-container matColumnDef="rating">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> RATING</th>
          <td mat-cell *matCellDef="let element"> {{ element.rating }}</td>
        </ng-container>

        <ng-container matColumnDef="loan_amount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> LOAN AMOUNT</th>
          <td mat-cell *matCellDef="let element"> ₹ {{ element.loan_amount }}</td>
        </ng-container>

        <ng-container matColumnDef="filled_percentage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> FILLED %</th>
          <td mat-cell *matCellDef="let element"> {{ element.filled_percentage | number : '1.1-2' }} %
          </td>
        </ng-container>

        <ng-container matColumnDef="loan_reason">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> LOAN REASON</th>
          <td mat-cell *matCellDef="let element"> {{ element.loan_reason}}</td>
        </ng-container>

        <ng-container matColumnDef="loan_details">
          <th mat-header-cell *matHeaderCellDef> DETAILS</th>
          <td mat-cell *matCellDef="let element">
            <a class="finzy-anchor" (click)="openDialog(element)">View Details </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="fund_allocation">
          <th mat-header-cell *matHeaderCellDef> FUND ALLOCATED</th>
          <td mat-cell *matCellDef="let element">
            <div class="col-xs-12 loancont finzy-padding-side-zero">
              <div class="row">
                <mat-form-field class="col-xs-8">
                  <input #amountInputField matInput type="number" min="1000" step="1000" required name="loanamt"
                         placeholder="max ₹ {{(getMaximumInvestmentAmount(element._id) | number : '1.1-2')}}"
                         [value]="getSelectedAmountForLoan(element._id)"
                         [disabled]="isLoanSelected(element)">
                </mat-form-field>
                <div>
                  <label class="investment-checkbox"
                         *ngIf="isValidInvestmentAmount(amountInputField.valueAsNumber, element._id) || isLoanSelected(element)"
                         style="margin-top: 15px;">

                    <input type="checkbox" name="addToPortfolio" class="finzy-add-to-portfolio"
                           (change)="onLoanAddedOrRemoved(element, amountInputField.valueAsNumber, $event.target.checked)"
                           [disabled]="isLoanSelected(element)">
                    <img *ngIf="!isLoanSelected(element)" class="img-responsive"
                         src="https://res.cloudinary.com/finzy/image/upload/v1490954548/success-_1_jtglxa.png"
                         alt="Add" style="cursor: pointer;">
                    <img *ngIf="isLoanSelected(element)" class="img-responsive"
                         src="https://res.cloudinary.com/finzy/image/upload/v1493895210/success-_1_jtglxa_albyq7.png"
                         alt="Added" style="cursor: pointer;">
                  </label>
                </div>
              </div>
            </div>

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 20, 30]"></mat-paginator>
    </div>
  </div>
  <div class="col col-md-3" *ngIf="areLoansAvailable()">
    <div class="col-md-12 finzy-padding-zero">
      <div class="col-md-1 finzy-padding-zero">
      </div>
      <div class="col-md-11 finzy-portfolio-container">

        <app-manual-invest-investment-title
                (titleChangedEvent)="onTitleChanged($event)" color="white" editColor="white"
                editTextColor="white"></app-manual-invest-investment-title>
        <hr>
        <p class="finzy-portfolio-sub-title finzy-invest-p">INVESTMENT AMOUNT</p>
        <p class="finzy-portfolio-investment finzy-invest-p">
          ₹ <span>{{getInvestmentAmount() | number : '1.1-2'}}</span>

          <!-- <i class="material-icons finzy-edit-icon">mode_edit</i> -->
        </p>


        <p class="finzy-portfolio-sub-title finzy-invest-p">INVESTMENT PENDING</p>

        <p class="finzy-portfolio-investment-penging finzy-invest-p-sm">

          ₹ {{getInvestmentAmount() - selectedInvestments.allocatedAmount() | number : '1.1-2'}}

        </p>

        <hr>

        <p class="finzy-portfolio-expected finzy-invest-p">
          EXPECTED RATE OF INTEREST
          <app-rate-of-return-tooltip></app-rate-of-return-tooltip>
        </p>

        <p class="finzy-portfolio-expected-roi">
          {{ xirr ? (xirr | number: '1.1-2') : '--' }}%
        </p>

      </div>


      <div class="col-md-12 finzy-padding-zero" *ngIf="dataSource.data?.length>0">
        <div class="col-md-1 finzy-padding-zero"></div>


        <div class="col-md-11 finzy-padding-zero finzy-portfolio-container-bottom"
             *ngIf="selectedInvestments.allocatedAmount() > 0">


          <!-- single portfolio starts -->

          <div class="col-md-12 finzy-padding-zero finzy-single-portfolio"
               *ngFor="let selectedInvestment of selectedInvestments let counter = index;">

            <div class="col-md-3 finzy-padding-zero finzy-border-right" id="{{counter}}">
              <p class="finzy finzy-margin-zero">
                <span class="finzy-portfolio-bottom-span">{{selectedInvestment.gaugedInvestment.loan.rating}}</span>
                <br>
                <span
                        class="finzy-portfolio-bottom-span-bottom finzy-margin-zero">{{selectedInvestment.gaugedInvestment.loan.roi | number : '1.1-2'}}
                  %
                </span>
              </p>
            </div>

            <div class="col-md-8 finzy-padding-zero finzy-padding-left-10">

              <p class="finzy-portfolio-location">{{selectedInvestment.gaugedInvestment.loan.correspondence_address.city}}
                ,
                {{selectedInvestment.gaugedInvestment.loan.loan_tenure / 12}}yrs</p>
              <p class="finzy-bold-p finzy-font-13"><span
                      class="finzy-portfolio-bottom-invest-span">Investment Amt.</span>
                ₹ {{selectedInvestment.amount | number :
                      '1.1-2'}}</p>
            </div>

            <div class="col-md-1 finzy-padding-zero finzy-text-center">

              <label>

                <input type="checkbox" name="removeToPortfolio" class="finzy-hide-checkbox" style="font-size: 20px;"
                       checked="checked"
                       [value]="selectedInvestment.gaugedInvestment.loan._id"
                       (change)="removeLoanFromPortfolio(selectedInvestment.gaugedInvestment.loan)">

                <img class="finzy-portfolio-add"
                     src="https://res.cloudinary.com/finzy/image/upload/v1490878959/portfolio-close_xtbvnn.png"
                     style="cursor: pointer;">


              </label>


            </div>


          </div>
          <!-- single portfolio ends -->

          <div class="finzy-submit-portfolio finzy-text-center" *ngIf="selectedInvestments.allocatedAmount() > 0">

            <p class="finzy-hybrid-text" *ngIf="!isFullInvestmentAmountAllocated()">
              You can choose to auto-invest the pending investment amount using finzyPRO+ by clicking on invest. Don't
              worry we will retain the loans you've already selected.
            </p>

            <!-- TODO Remove duplicates -->

            <div class="row text-justify">
              <div class="col-md-12 declaration-checkbox">
                <mat-checkbox #declarationCheck [(ngModel)]="lender50kLimitDeclarationCheck"
                              name="investedAmountDeclarationCheck"></mat-checkbox>
                <p class="declaration-text terms-and-conditions-text">I, hereby confirm that, my investment in each of the borrowers
                  listed below (including the amount I currently propose to invest) does not exceed &#8377; 50,000
                  across all the P2P
                  platforms in India.</p>
                <br/>
                <span class="error"
                      *ngIf="lender50KLimitErrorMessage && !declarationCheck.checked">{{lender50KLimitErrorMessage}}</span>
              </div>
            </div>

            <button mat-flat-button class="primary" type="submit"
                    *ngIf="!isFullInvestmentAmountAllocated()"
                    (click)="proceedToNextStep()">
              <span>INVEST</span>
              <i class="material-icons">arrow_forward</i>
            </button>

            <button mat-flat-button class="primary" type="submit"
                    *ngIf="isFullInvestmentAmountAllocated()"
                    (click)="proceedToNextStep()">
              <span>CONFIRM PORTFOLIO</span>
              <i class="material-icons">arrow_forward</i>
            </button>

            <p class="finzy-anchor" (click)="returnToDashboard()">THANKS, BUT I WILL INVEST LATER</p>
          </div>

        </div>
        <!-- dummy	 -->
        <div class="col-md-12 finzy-padding-zero finzy-blur" *ngIf="selectedInvestments.allocatedAmount() === 0">
          <div class="col-md-12 finzy-padding-zero">
            <div class="col-md-1 finzy-padding-zero"></div>

            <div class="col-md-11 finzy-padding-zero finzy-portfolio-container-bottom">

              <div class="col-md-12 finzy-padding-zero finzy-single-portfolio">

                <div class="col-md-3 finzy-padding-zero finzy-border-right" ng-reflect-id="0" id="0">

                  <div class="finzy finzy-margin-zero">

                    <span class="finzy-portfolio-bottom-span">B1</span>
                    <br>
                    <p class="finzy-portfolio-bottom-span-bottom finzy-margin-zero">
                      16.99 %
                    </p>
                  </div>
                </div>

                <div class="col-md-8 finzy-padding-zero finzy-padding-left-10">

                  <p class="finzy-portfolio-location">Bengaluru, 3yrs</p>
                  <p class="finzy-bold-p"><span class="finzy-portfolio-bottom-invest-span">Investment Amt.</span> ₹
                    1,000</p>
                </div>

                <div class="col-md-1 finzy-padding-zero finzy-text-center">

                  <label>

                    <input class="finzy-hide-checkbox ng-untouched ng-pristine ng-valid" name="removeToPortfolio"
                           style="font-size: 20px;" type="checkbox" ng-reflect-name="removeToPortfolio"
                           ng-reflect-value="58f8cc657c37180bc601ca48" value="58f8cc657c37180bc601ca48"
                           ng-reflect-model="true">

                    <img src="https://res.cloudinary.com/finzy/image/upload/v1490878959/portfolio-close_xtbvnn.png"
                         alt="Remove loan from portfolio">
                  </label>
                </div>
              </div>

              <div class="col-md-12 finzy-padding-zero finzy-single-portfolio">

                <div class="col-md-3 finzy-padding-zero finzy-border-right">

                  <div class="finzy finzy-margin-zero">

                    <span class="finzy-portfolio-bottom-span">B1</span>
                    <br>
                    <p class="finzy-portfolio-bottom-span-bottom finzy-margin-zero">
                      16.99 %
                    </p>
                  </div>
                </div>

                <div class="col-md-8 finzy-padding-zero finzy-padding-left-10">

                  <p class="finzy-portfolio-location">Bengaluru, 3yrs</p>
                  <p class="finzy-bold-p">
                    <span class="finzy-portfolio-bottom-invest-span">Investment Amt.</span> ₹ 1,000
                  </p>
                </div>

                <div class="col-md-1 finzy-padding-zero finzy-text-center">
                  <label>
                    <input class="finzy-hide-checkbox ng-untouched ng-pristine ng-valid" name="removeToPortfolio"
                           style="font-size: 20px;" type="checkbox" ng-reflect-name="removeToPortfolio"
                           ng-reflect-value="58f8cc657c37180bc601ca48" value="58f8cc657c37180bc601ca48"
                           ng-reflect-model="true">

                    <img src="https://res.cloudinary.com/finzy/image/upload/v1490878959/portfolio-close_xtbvnn.png"
                         alt="Remove loan from portfolio">
                  </label>
                </div>
              </div>
              <div class="finzy-submit-portfolio finzy-text-center">
                <button mat-flat-button class="primary">
                  <span>CONFIRM PORTFOLIO</span>
                  <i class="material-icons">arrow_forward</i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12 no-loans pt-2" *ngIf="!areLoansAvailable()">

    <img src="../../../assets/images/no-loan-icon.svg"/>

    <p class="heading">
      We didn't find any loans. But we have you covered!
    </p>

    <p class="sub-title col-md-9">
      At the moment, there aren't any loans available. However, finzyPRO+ ensures that this does not stop you from
      investing with us. We will automatically invest your funds in new loans as they get listed on finzy everyday.
      You can also choose to set your preferences with custom finzyPRO+.
      <br/>
      <strong>
        Loans are getting filled fast on finzy! See the loans funded by other investors <a [routerLink]="['/recently-filled-loans']">here.</a>
      </strong>
    </p>



    <div style="margin-top: 20px;">
      <button mat-flat-button class="primary" (click)="proceedToNextStep()">CONTINUE TO INVEST</button>
    </div>

    <a class="invest-later" (click)="investLater()">NO THANKS, LATER</a>

  </div>
</div>
<app-footer></app-footer>
